/**
 * Shared helpers for hotel selector filtering and sorting.
 * Used by HotelSelector (group order) and HotelSelectorGroup (filter + item order).
 */
export function getSearchableString(h, groupName) {
  return (h.subsidiaryName || '') + ' #' + (h.displayId ?? '') + ' ' + (groupName || '')
}
